import { render, staticRenderFns } from "./FeedFilter.vue?vue&type=template&id=5f124b79&scoped=true&"
import script from "./FeedFilter.vue?vue&type=script&lang=js&"
export * from "./FeedFilter.vue?vue&type=script&lang=js&"
import style0 from "./FeedFilter.vue?vue&type=style&index=0&id=5f124b79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f124b79",
  null
  
)

export default component.exports